import getHeat from './getHeat'

export default function getSegmentHeats(items, segmentLength) {
  const itemCount = items.length
  let segment = {
    raw: 0,
    possible: 0,
    count: 0,
    number: 1,
  }
  let segmentHeats = []
  items.forEach((item, n) => {
    if (segment.count + 1 === segmentLength || items.length === n + 1) {
      segment.raw += item.raw
      segment.possible += item.possible
      segment.count++
      segmentHeats.push({
        heat: getHeat(segment.raw, segment.possible),
        itemNumber: segment.number
      })
      segment = {
        raw: 0,
        possible: 0,
        count: 0,
        number: segment.number + 1,
      }
    } else {
      segment.raw += item.raw
      segment.possible += item.possible
      segment.count++
    }
  })
  return segmentHeats
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/getSegmentHeats.js